<template>
    <div>
        <div>
            <div class="list">
                <EditItemList/>
            </div>
            <div v-if="editing_item" class="edit">
                <div class="input">
                    <InputRectSize/>
                </div>
                <div class="buttons floor" v-if="editing_item.item_data && editing_item.item_data.can_itimatsu">
                    <button @click="setItimatsu(false)">流し貼り</button>
                    <button @click="setItimatsu(true)">市松貼り</button>
                </div>
<!--                <div class="buttons curtain" v-if="editing_item.item_type === CONST.ITEM_TYPE_CURTAIN">-->
                <div class="buttons curtain" v-if="false">
                    <button @click="setCurtainType(CONST.CURTAIN_TYPE_DOUBLE)" :class="{selected: editing_item.curtain_type === CONST.CURTAIN_TYPE_DOUBLE}">両開き</button>
                    <button @click="setCurtainType(CONST.CURTAIN_TYPE_SINGLE)" :class="{selected: editing_item.curtain_type === CONST.CURTAIN_TYPE_SINGLE}">片開き</button>
                    <button @click="setCurtainType(CONST.CURTAIN_TYPE_PLANE_SHADE)" :class="{selected: editing_item.curtain_type === CONST.CURTAIN_TYPE_PLANE_SHADE}">プレーン<br>シェード</button>
                </div>
                <div class="buttons">
                    <button class="button_change" @click="setModal('SelectItem')">
                        <img src="../../assets/img/change.svg" alt="change"><span>商品変更</span>
                    </button>
                    <button class="button_change" @click="setModal('ChangeStyle')">
                        <img src="../../assets/img/change.svg" alt="change"><span>スタイル変更</span>
                    </button>
                    <button class="button_delete" @click="removeItemData(editing_id)">
                        <img src="../../assets/img/delete.svg" alt="delete"><span>削除</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    import EditItemList from '../parts/EditItemList'
    import InputRectSize from '../parts/InputRectSize'
    import CONST from '../../assets/js/const'

    export default {
        name: "DefaultMenu",
        components: { EditItemList, InputRectSize },
        data: () => ({
            CONST
        }),
        computed: {
            ...mapState('simulator', ["editing_id"]),
            ...mapGetters('simulator', ["editing_item"])
        },
        mounted() {
            document.addEventListener('keydown', this.onKeyDown)
        },
        beforeDestroy() {
            document.removeEventListener('keydown', this.onKeyDown)
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapActions('simulator', ["updateItemInfo", "removeItemData"]),
            setItimatsu(is_check_pattern) {
                this.updateItemInfo({id: this.editing_id, is_check_pattern})
            },
            setCurtainType(curtain_type) {
                this.updateItemInfo({id: this.editing_id, curtain_type})
            },
            onKeyDown(event) {
                if(event.keyCode == 46) {
                    this.removeItemData(this.editing_id);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    .edit{
        .buttons{
            display: flex;
            justify-content: space-between;
            max-width: 350px;
            margin: auto;
            padding: 0 1rem;
        }
         > *:not(:last-child){
            margin-bottom: 1rem;
        }
    }

    .list{
        margin-bottom: 1rem;
    }
    @media (orientation: landscape) and (max-width: 992px) {
        .list{
            margin-bottom: 0rem;
        }
    }
    @media screen and (max-width:650px) {
        .list{
            margin-bottom: 0rem;
        }
    }

    .button_change{
    }

    .buttons.floor button, .buttons.curtain button{

    }

    .buttons button{
        margin: 0;
        display: inline-flex;
        align-items: center;
        font-size: 10px;
        width: auto;
        padding: 0 0.5rem;
    }
    @media screen and (max-width:650px) {
        .buttons button{
            padding: 0rem;
        }
    }
    .buttons.floor button{
        margin: 0;
        display: inline-block;
        width: calc((100% / 2) - 0.5rem);
        padding: 0 0.5rem;
    }

    .buttons.curtain button{
        margin: 0;
        font-size: 12px;
        display: inline-block;
        height: 3rem;
        width: calc((100% / 3) - 0.5rem);
        padding: 0 0.5rem;
    }

</style>
